module.exports = __webpack_public_path__ + "img/victoria.5aa4c656.png";